import { type ReactNode } from 'react'

import { cn } from '@/utils/commonUtil'
import { formatFullNumber, formatSigFig } from '@/utils/formatUtil'

import styles from './Badge.module.scss'

type Props = {
  children?: ReactNode
  count: number
  isCompact?: boolean
  isSelected?: boolean
}

export const Badge = ({ children, count, isCompact, isSelected }: Props) => (
  <span className={cn(styles.container, { isSelected, styles })}>
    <span>{isCompact ? formatSigFig(count) : formatFullNumber(count)}</span>
    {children && <span>{children}</span>}
  </span>
)
